import { useEffect } from 'react';

const handleIntersections = (
  entries: IntersectionObserverEntry[],
  observer: IntersectionObserver,
  callback: () => void,
  target: HTMLElement
) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      callback();
      observer.unobserve(target);
    }
  });
};

export const useInitialIntersection = (
  element: React.RefObject<HTMLElement>,
  callback: () => void,
  margin?: string
) => {
  // The IntersectionObserver start half a viewport before the entering of the real viewport to give the asset time to load
  const rootMargin = typeof window !== 'undefined' ? `${window.innerHeight / 2}px` : '0px';

  const observerOptions = {
    root: null,
    rootMargin: margin || rootMargin,
    threshold: 0
  };

  useEffect(() => {
    const target = element.current;

    if (target) {
      const intersectionObserver = new IntersectionObserver(
        (entries, observer) => handleIntersections(entries, observer, callback, target),
        observerOptions
      );

      intersectionObserver.observe(target);
    }
  });
};
